import dayjs from "@/lib/dayjs";

import { getTodaysDate } from "../get-todays-date";

/**
 * 操作日の年の前後1年の範囲を文字列の配列で取得する
 */
export function getYearRange() {
	const today = getTodaysDate();

	const thisYear = dayjs(today).year();
	const lastYear = thisYear - 1;
	const nextYear = thisYear + 1;
	const yearAfterNext = thisYear + 2;

	return [lastYear, thisYear, nextYear, yearAfterNext].map((year) => year.toString());
}

export const MONTHS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
